import { Download } from "lucide-react";
import CustomTooltip from "../../Tooltip/CustomTooltip";

/**
 * Shared download button used in visualizations and diagrams.
 *
 * @param {object} props
 * @param {function} props.onClick - Click handler (should call downloadFile)
 * @param {string} [props.tooltip="Download"] - Tooltip text
 * @param {string} [props.className] - Additional button classes to merge
 * @param {React.ReactNode} [props.icon] - Custom icon (defaults to FaDownload)
 */
const VizDownloadButton = ({ onClick, tooltip = "Download", className = "", icon }) => {
  const baseClasses =
    "flex items-center p-2 bg-fill-white dark:bg-fill-editor-surface border-[0.5px] dark:border-edge-editor-border border-edge-border text-ink-ink dark:text-ink-white rounded-lg hover:bg-fill-gray-100 dark:hover:bg-fill-editor-hover transition-colors";

  return (
    <CustomTooltip content={tooltip} side="top" align="center">
      <button className={`${baseClasses} ${className}`} onClick={onClick}>
        {icon || <Download className="w-3.5 h-3.5 hover:scale-110 transition-transform" />}
      </button>
    </CustomTooltip>
  );
};

export default VizDownloadButton;
